export default __webpack_public_path__ + "static/media/worldmaps.aa65eb19.png";